export class StepGuard {
  constructor(private _wizzardName: string = null,
              private _wizzardStepNumber: number = null) {
  }

  get wizzardName(): string {
    return this._wizzardName;
  }

  get wizzardStepNumber(): number {
    return this._wizzardStepNumber;
  }

}



// WEBPACK FOOTER //
// ./src/app/core/model/step-guard.ts